import { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";

export const shippingUserNavigation: NiceNavigationItem[] = [
    {
        id: "home",
        type: "group",
        children: [
            {
                id: "shipping",
                title: "navigation.shipping.title",
                type: "collapsable",
                iconType: "fontawesome",
                icon: "fa-duotone fa-truck-moving text-primary",
                children: [
                    {
                        id: "dashboard",
                        title: "navigation.shipping.tickets_to_deliver",
                        type: "basic",
                        iconType: "fontawesome",
                        icon: "fa-duotone fa-bars-staggered",
                        link: "/dashboard/to-deliver"
                    }
                ]
            }
        ]
    }
];
